import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../actions/organization/organization-listings';

import OrganizationListingComponent from '../../components/app/Organization/OrganizationListing';

const OrganizationListing = (props) => {
  return (
    <OrganizationListingComponent {...props} />
  );
};

export default connect(({ organization, user }) => ({ organizationListing: organization.organizationListings, user }), actions)(OrganizationListing);

